<style lang="less" scoped>
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
    padding: 0;
    border: none;
}
td > input {
    min-width: 5em;
}
.table > thead > tr > th {
    padding-left: 1em;
}
td > button.btn {
    margin: 0;
    border-radius: 0;
}
legend {
    background: #ffffff;
    width: auto;
    margin: auto auto 10px auto;
    padding: 5px 15px;
    cursor: pointer;
    font-weight: normal;
}
.btn .icon {
    line-height: initial;
    vertical-align: baseline;
}
::v-deep(.htmlContent) {
    text-align: initial;
    color: initial;
    outline: none !important;
    padding: 10px;
    background: #ffffff;
    border: 1px dashed #bbbbbb;
    border-radius: 0.25rem;
    width: 100%;

    p:last-of-type {
        margin-bottom: 0;
    }
}
caption {
    caption-side: top;
}
</style>
<template>
    <div id="tenantSection" class="admin-content tenant-editor-content" role="main" aria-label="Tenant Editor">
        <LoadingPlaceholder v-if="loading" />
        <div v-if="!loading">
            <div>
                <div v-show="saveErrors.length > 0" class="validation-summary-errors">
                    <ul>
                        <li v-for="error in saveErrors">{{ error }}</li>
                    </ul>
                </div>
                <!--
                <div v-show="saveErrorsDetailed.length > 0" class="validation-summary-errors">
                    <dl>
                        <template v-for="error in saveErrorsDetailed">
                            <dt>{{ error.key }}</dt>
                            <dd>{{ error.message }}</dd>
                        </template>
                    </dl>
                </div>
                -->
                <div class="admin-content-banner tenant-editor-banner">
                    <a @click.prevent="changePage({ page: 'AdminTenantManagementIndex' })" :href="indexUrl" class="btn-sm back-link icon icon-arrow-left mr-auto my-0 px-0">Tenants</a>
                    <div class="ml-auto">
                        <div class="btn btn-bare btn-sm">
                            <span v-if="saveStatus == 'ok'" class="icon icon-check"></span>
                            <span v-if="saveStatus == 'fail'" class="icon icon-attention"></span>
                            <LoadingWheel :width="16" v-if="saveStatus == 'in-progress'" style="vertical-align: middle; display: inline" />
                        </div>
                        <button type="button" value="Save" class="btn btn-primary btn-sm ml-1" @click="save">Save</button>
                        <button type="button" value="Export" class="btn btn-outline-secondary btn-sm ml-1" @click="exportFunc">Export</button>
                        <button type="button" value="Import" class="btn btn-outline-secondary btn-sm ml-1" @click="importFunc">Import</button>
                        <button type="button" value="Delete" class="btn btn-outline-danger btn-sm ml-1" @click="showDeleteModal" :enabled="deletable">Delete</button>
                    </div>
                </div>
                <h1 class="admin-content-heading">Edit</h1>
                <div>
                    <div>
                        <div class="form-group">
                            <label for="code">Code</label>
                            <p class="form-control-static" id="code">{{ code }}</p>
                            <!--
        @Html.HiddenFor(i => i.Code)
        -->
                        </div>
                        <div class="form-group">
                            <label for="urlSlug">Name in URL</label>
                            <input class="form-control" id="urlSlug" type="text" v-model="urlSlug" />
                            <!--
        @Html.ValidationMessageFor(i => i.UrlSlug)
        -->
                        </div>
                        <div class="form-group">
                            <label for="domain">Domain</label>
                            <input class="form-control" id="domain" type="text" v-model="domain" />
                            <!--
        @Html.ValidationMessageFor(i => i.UrlSlug)
        -->
                        </div>
                        <div class="form-group">
                            <label for="type">Type</label>
                            <select class="form-control" id="type" v-model="type">
                                <option :value="null">-- Select a type --</option>
                                <option :value="item.value" v-for="item in typeOptions">{{ item.label }}</option>
                            </select>
                            <!--
        @Html.ValidationMessageFor(i => i.Type)
        -->
                        </div>
                        <div class="form-group">
                            <label for="displayLabel">Display Label</label>
                            <input class="form-control" id="displayLabel" type="text" v-model="displayLabel" />
                            <!--
        @Html.ValidationMessageFor(i => i.DisplayLabel)
        -->
                        </div>
                        <div class="form-group">
                            <label for="externalHomePageUrl">External Home Page URL</label>
                            <input class="form-control" id="externalHomePageUrl" type="text" v-model="externalHomePageUrl" />
                            <!--
        @Html.ValidationMessageFor(i => i.ExternalHomePageUrl)
        -->
                        </div>
                        <div class="form-group">
                            <label for="description">Description</label>
                            <input class="form-control" id="description" type="text" v-model="description" />
                            <!--
        @Html.ValidationMessageFor(i => i.Description)
        -->
                        </div>
                        <div class="form-group">
                            <label for="tier">Tier</label>
                            <select class="form-control" id="tier" v-model="tier">
                                <option :value="null">-- Select a tier --</option>
                                <option :value="item.value" v-for="item in tierOptions">{{ item.label }}</option>
                            </select>
                            <!--
        @Html.ValidationMessageFor(i => i.Tier)
        -->
                        </div>
                        <div class="form-group">
                            <label for="timeZone">Time Zone</label>
                            <select class="form-control" id="timeZone" v-model="timeZone">
                                <option :value="null">-- Select a time zone --</option>
                                <option :value="item.value" v-for="item in timeZoneOptions">{{ item.label }}</option>
                            </select>
                            <!--
        @Html.ValidationMessageFor(i => i.TimeZone)
        -->
                        </div>
                        <div class="form-group">
                            <label for="publicAreaEnabled">Public Area Enabled</label>
                            <select class="form-control" id="publicAreaEnabled" v-model="publicAreaEnabled">
                                <option :value="null">-- Use default --</option>
                                <option :value="true">Enabled</option>
                                <option :value="false">Disabled</option>
                            </select>
                            <!--
        @Html.ValidationMessageFor(i => i.PublicAreaEnabled)
        -->
                        </div>
                        <div class="form-group">
                            <label for="adminAreaEnabled">Admin Area Enabled</label>
                            <select class="form-control" id="adminAreaEnabled" v-model="adminAreaEnabled">
                                <option :value="null">-- Use default --</option>
                                <option :value="true">Enabled</option>
                                <option :value="false">Disabled</option>
                            </select>
                            <!--
        @Html.ValidationMessageFor(i => i.AdminAreaEnabled)
        -->
                        </div>
                        <div class="form-group">
                            <label for="parentCode">Parent</label>
                            <select class="form-control" id="parentCode" v-model="parentCode">
                                <option :value="null">-- None --</option>
                                <option :value="item.value" v-for="item in parentTenantOptions">{{ item.label }}</option>
                            </select>
                            <!--
        @Html.ValidationMessageFor(i => i.ParentCode)
        -->
                        </div>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('logo')">
                                <a tabindex="0" role="button" style="color: inherit">Logo</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('logo') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('logo')">
                                <div>
                                    <div class="form-group">
                                        <label for="logo">Logo</label>
                                        <p v-if="hasLogoImage && logoUrl != null">
                                            <img :src="logoUrl" :alt="logoAlt" />
                                        </p>
                                        <input type="file" ref="logoImageRef" id="logo" />
                                        <span>
                                            <HelpIcon :text="'Acceptable logos are png, jpg, gif, svg, or webp images. The logo must be less than 29 MBs.'" />
                                        </span>
                                        <!--
    @Html.ValidationMessageFor(i => i.LogoImage)
    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="logoAlt">Logo Alt</label>
                                        <input class="form-control" id="logoAlt" type="text" v-model="logoAlt" />
                                        <!--
            @Html.ValidationMessageFor(i => i.LogoAlt)
            -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="favicon">Browser Tab Icon (Favicon)</label>
                                        <p v-if="hasFaviconImage && faviconUrl != null">
                                            <img :src="faviconUrl" :alt="faviconAlt" />
                                        </p>
                                        <input type="file" ref="faviconImageRef" id="favicon" />
                                        <span>
                                            <HelpIcon :text="'Acceptable favicon are png or gif images. The favicon must be less than 29 MBs.'" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('design')">
                                <a tabindex="0" role="button" style="color: inherit">Design</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('design') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('design')">
                                <div>
                                    <div class="form-group">
                                        <label for="primaryColor">Primary Color</label>
                                        <input class="form-control" id="primaryColor" type="text" v-model="primaryColor" />
                                        <!--
                    @Html.LabelFor(i => i.PrimaryColor)
                    @Html.TextBoxFor(i => i.PrimaryColor, new { @class = "form-control" })
                    @Html.ValidationMessageFor(i => i.PrimaryColor)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="secondaryColor">Secondary Color</label>
                                        <input class="form-control" id="secondaryColor" type="text" v-model="secondaryColor" />
                                        <!--
                    @Html.LabelFor(i => i.SecondaryColor)
                    @Html.TextBoxFor(i => i.SecondaryColor, new { @class = "form-control" })
                    @Html.ValidationMessageFor(i => i.SecondaryColor)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="customLess">Custom LESS</label>
                                        <div class="ml-auto d-inline-block ml-1">
                                            <button type="button" id="customLessSaveBtn" value="Save" class="btn btn-primary btn-sm ml-1" @click="saveCustomLess"><AsyncOperationStatus :promise="saveCustomLessPromise" /> Save</button>
                                            <button type="button" id="enableStyleEditorModeBtn" value="Save" class="btn btn-outline-secondary btn-sm ml-1" v-if="notInStyleEditorMode" @click="enableStyleEditorMode"><AsyncOperationStatus :promise="setStyleEditorModePromise" /> Enable Style Editor Mode</button>
                                            <span v-else class="ml-1 icon icon-check editor-help-text d-inline-flex align-items-center ml-1">&nbsp;Style Editor Mode enabled</span>
                                            <HelpIcon :text="'Style Editor Mode disables caching for your user, allowing you to see updates faster.'" />
                                        </div>
                                        <AsyncOperationErrors :promise="saveCustomLessPromise" />
                                        <textarea class="form-control" id="customLess" v-model="customLess" />
                                        <!--
                    @Html.LabelFor(i => i.CustomLess)
                    @Html.TextAreaFor(i => i.CustomLess, new { @class = "form-control", rows = 20 })
                    @Html.ValidationMessageFor(i => i.CustomLess)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="customFooterHtml">Custom Footer HTML</label>
                                        <DfTinyMceEditor class="htmlContent clearfix" v-model="customFooterHtml" />
                                        <!--
                    <textarea class="form-control" id="customFooterHtml" v-model="customFooterHtml" />
                    @Html.LabelFor(i => i.CustomFooterHtml)
                    @Html.TextAreaFor(i => i.CustomFooterHtml, new { @class = "form-control", rows = 20 })
                    @Html.ValidationMessageFor(i => i.CustomFooterHtml)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="customErrorHtml">Custom Error HTML</label>
                                        <DfTinyMceEditor class="htmlContent clearfix" v-model="customErrorHtml" />
                                        <!--
                    <textarea class="form-control" id="customErrorHtml" v-model="customErrorHtml" />
                    @Html.LabelFor(i => i.CustomErrorHtml)
                    @Html.TextAreaFor(i => i.CustomErrorHtml, new { @class = "form-control", rows = 20 })
                    @Html.ValidationMessageFor(i => i.CustomErrorHtml)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="customNotFoundHtml">Custom Not Found HTML</label>
                                        <DfTinyMceEditor class="htmlContent clearfix" v-model="customNotFoundHtml" />
                                        <!--
                    <textarea class="form-control" id="customNotFoundHtml" v-model="customNotFoundHtml" />
                    @Html.LabelFor(i => i.CustomNotFoundHtml)
                    @Html.TextAreaFor(i => i.CustomNotFoundHtml, new { @class = "form-control", rows = 20 })
                    @Html.ValidationMessageFor(i => i.CustomNotFoundHtml)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="customUserInviteEmailSubject">Custom User Invite Email Subject</label>
                                        <input class="form-control" id="customUserInviteEmailSubject" type="text" v-model="customUserInviteEmailSubject" />
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="customUserInviteEmailHtml">Custom User Invite Email HTML</label>
                                        <DfTinyMceEditor class="htmlContent clearfix" v-model="customUserInviteEmailHtml" :inviteEmailContentMenuHandler="inviteEmailContentMenuHandler" />
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('billing')">
                                <a tabindex="0" role="button" style="color: inherit">Billing</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('billing') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('billing')">
                                <div>
                                    <div class="form-group">
                                        <label for="billingServiceCode">CDB Service Code</label>
                                        <input class="form-control" id="billingServiceCode" type="text" v-model="billingServiceCode" />
                                        <!--
                    @Html.LabelFor(i => i.BillingServiceCode)
                    @Html.TextBoxFor(i => i.BillingServiceCode, new { @class = "form-control" })
                    @Html.ValidationMessageFor(i => i.BillingServiceCode)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="billingCustomerId">CDB Customer ID</label>
                                        <input class="form-control" id="billingCustomerId" type="number" v-model="billingCustomerId" />
                                        <!--
                    @Html.LabelFor(i => i.BillingCustomerId)
                    @Html.TextBoxFor(i => i.BillingCustomerId, new { @class = "form-control" })
                    @Html.ValidationMessageFor(i => i.BillingCustomerId)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="billingLogin">CDB Login</label>
                                        <input class="form-control" id="billingLogin" type="text" v-model="billingLogin" />
                                        <!--
                    @Html.LabelFor(i => i.BillingLogin)
                    @Html.TextBoxFor(i => i.BillingLogin, new { @class = "form-control" })
                    @Html.ValidationMessageFor(i => i.BillingLogin)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="billingStoredPaymentId">CDB Stored Payment ID</label>
                                        <input class="form-control" id="billingStoredPaymentId" type="number" v-model="billingStoredPaymentId" />
                                        <!--
                    @Html.LabelFor(i => i.BillingStoredPaymentId)
                    @Html.TextBoxFor(i => i.BillingStoredPaymentId, new { @class = "form-control" })
                    @Html.ValidationMessageFor(i => i.BillingStoredPaymentId)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="billingPerUserCost">Per-user Cost</label>
                                        <input class="form-control" id="billingPerUserCost" type="number" v-model="billingPerUserCost" />
                                        <!--
                    @Html.LabelFor(i => i.BillingPerUserCost)
                    @Html.TextBoxFor(i => i.BillingPerUserCost, new { @class = "form-control" })
                    @Html.ValidationMessageFor(i => i.BillingPerUserCost)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="billingUserMinimalCost">User Minimal Cost</label>
                                        <input class="form-control" id="billingUserMinimalCost" type="number" v-model="billingUserMinimalCost" />
                                        <!--
                    @Html.LabelFor(i => i.BillingUserMinimalCost)
                    @Html.TextBoxFor(i => i.BillingUserMinimalCost, new { @class = "form-control" })
                    @Html.ValidationMessageFor(i => i.BillingUserMinimalCost)
                    -->
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="billingTenantInstanceCost">Instance Cost</label>
                                        <input class="form-control" id="billingTenantInstanceCost" type="text" v-model="billingTenantInstanceCost" />
                                        <!--
                    @Html.LabelFor(i => i.BillingTenantInstanceCost)
                    @Html.TextBoxFor(i => i.BillingTenantInstanceCost, new { @class = "form-control" })
                    @Html.ValidationMessageFor(i => i.BillingTenantInstanceCost)
                    -->
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('controls')">
                                <a tabindex="0" role="button" style="color: inherit">Controls</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('controls') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('controls')">
                                <template v-for="(componentConfiguration, componentConfigurationIndex) in componentConfigurations">
                                    <div class="form-group row">
                                        <!--
                    <input type="hidden" data-bind="value: name, attr: { name: 'ComponentConfigurations['+$index()+'].Key' }" />
                    -->
                                        <label class="col-sm-4 text-right control-label" :for="'ComponentConfigurations' + componentConfigurationIndex + '_Value_Enabled'">{{ componentConfiguration.label }}</label>
                                        <div class="col-sm-8">
                                            <select v-model="componentConfiguration.enabled" :id="'ComponentConfigurations' + componentConfigurationIndex + '_Value_Enabled'" class="form-control">
                                                <option :value="null">-- Use default --</option>
                                                <option value="true">Enabled</option>
                                                <option value="false">Disabled</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div style="padding-left: 3em" v-for="(table, tableIndex) in componentConfiguration.tables">
                                        <!--
                    <input type="hidden" data-bind="value: name, attr: { name: 'ComponentConfigurations['+$parentContext.$index()+'].Value.Tables['+$index()+'].Name' }" />
                    -->
                                        <div class="table-responsive">
                                            <table class="table">
                                                <caption>
                                                    {{
                                                        table.name
                                                    }}
                                                    Configuration
                                                </caption>
                                                <thead>
                                                    <tr>
                                                        <template v-for="(key, keyIndex) in table.keys">
                                                            <th :id="'ComponentConfigurations' + componentConfigurationIndex + '_Value' + tableIndex + '_Data' + keyIndex + '_Label'" v-if="keyIndex != 0">{{ key }}</th>
                                                        </template>
                                                        <th><span class="sr-only">Action</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, rowIndex) in table.data">
                                                        <template v-for="(_, cellIndex) in row">
                                                            <td v-if="cellIndex != 0">
                                                                <!--
        data-bind="value: $data, attr: { name: 'ComponentConfigurations['+$parentContext.$parentContext.$parentContext.$index()+'].Value.Tables['+$parentContext.$parentContext.$index()+'].Data['+$parentContext.$index()+']['+$index()+'].Value', 'aria-labelledby': 'ComponentConfigurations'+$parentContext.$parentContext.$parentContext.$index()+'_Value'+$parentContext.$parentContext.$index()+'_Data'+$index()+'_Label' }
                                                                -->
                                                                <input class="form-control" v-model="row[cellIndex]" :aria-labelledby="'ComponentConfigurations' + componentConfigurationIndex + '_Value' + tableIndex + '_Data' + cellIndex + '_Label'" />
                                                                <!--
        <input type="hidden" data-bind="value: $parent.keys[$index()], attr: { name: 'ComponentConfigurations['+$parentContext.$parentContext.$parentContext.$index()+'].Value.Tables['+$parentContext.$parentContext.$index()+'].Data['+$parentContext.$index()+']['+$index()+'].Key' }">
        -->
                                                            </td>
                                                        </template>
                                                        <td>
                                                            <button type="button" class="btn btn-outline-secondary config-delete" @click.prevent="removeRow(table, row, rowIndex)" hidden="hidden">Delete</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td :colspan="table.keys.length + 1"><button type="button" class="btn btn-outline-secondary" :class="(table.name || '').replace(/\s+/g, '')" @click.prevent="addRow(table)">Add Row</button></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('role')">
                                <a tabindex="0" role="button" style="color: inherit">Roles</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('role') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('role')">
                                <div class="form-group row" v-for="(roleConfiguration, roleConfigurationIndex) in roleConfigurations">
                                    <!--
                <input type="hidden" data-bind="value: name, attr: { name: 'RoleConfigurations['+$index()+'].Key' }" />
                -->
                                    <label class="col-sm-4 text-right control-label" :for="'RoleConfigurations' + roleConfigurationIndex + '_Value_Enabled'">{{ roleConfiguration.label }}</label>
                                    <div class="col-sm-8">
                                        <select v-model="roleConfiguration.enabled" :id="'RoleConfigurations' + roleConfigurationIndex + '_Value_Enabled'" class="form-control">
                                            <option :value="null">-- Use default --</option>
                                            <option value="true">Enabled</option>
                                            <option value="false">Disabled</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('permission')">
                                <a tabindex="0" role="button" style="color: inherit">Permissions</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('permission') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('permission')">
                                <div class="form-group row" v-for="(permissionConfiguration, permissionConfigurationIndex) in permissionConfigurations">
                                    <!--
                <input type="hidden" data-bind="value: name, attr: { name: 'PermissionConfigurations['+$index()+'].Key' }" />
                -->
                                    <label class="col-sm-4 text-right control-label" :for="'PermissionConfigurations' + permissionConfigurationIndex + '_Value_Enabled'">{{ permissionConfiguration.label }}</label>
                                    <div class="col-sm-8">
                                        <select v-model="permissionConfiguration.enabled" :for="'PermissionConfigurations' + permissionConfigurationIndex + '_Value_Enabled'" class="form-control">
                                            <option :value="null">-- Use default --</option>
                                            <option value="true">Enabled</option>
                                            <option value="false">Disabled</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('pageCountLimits')">
                                <a tabindex="0" role="button" style="color: inherit">Page Counts</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('pageCountLimits') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('pageCountLimits')">
                                <div class="form-group row" v-for="(pageCountLimitConfiguration, pageCountLimitConfigurationIndex) in pageCountLimitConfigurations">
                                    <!--
                <input type="hidden" data-bind="value: name, attr: { name: 'PageCountLimitConfigurations['+$index()+'].Key' }" />
                -->
                                    <label class="col-sm-4 text-right control-label" :for="'PageCountLimitConfigurations' + pageCountLimitConfigurationIndex + '_Value_Count'">{{ pageCountLimitConfiguration.label }}</label>
                                    <div class="col-sm-8">
                                        <input type="number" placeholder="-- Use default --" v-model="pageCountLimitConfiguration.count" :id="'PageCountLimitConfigurations' + pageCountLimitConfigurationIndex + '_Value_Count'" class="form-control" />
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('authenticationSchemas')">
                                <a tabindex="0" role="button" style="color: inherit">Authentication Schemas</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('authenticationSchemas') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div class="form-group row" v-show="isSectionOpen('authenticationSchemas')">
                                <label class="col-sm-4 text-right control-label" for="DefaultAuthenticationSchema">Default Authentication Schema</label>
                                <div class="col-sm-8">
                                    <select v-model="defaultAuthenticationSchema" id="DefaultAuthenticationSchema" class="form-control">
                                        <option :value="null">-- Use default --</option>
                                        <option :value="authenticationSchema.id" v-for="authenticationSchema in authenticationSchemaConfigurations">{{ authenticationSchema.label }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-show="isSectionOpen('authenticationSchemas')">
                                <label class="col-sm-4 text-right control-label" for="DefaultModeAuthenticationSchema_0">Default User Authentication Schema</label>
                                <div class="col-sm-8">
                                    <select v-model="defaultModeAuthenticationSchema['User']" id="DefaultModeAuthenticationSchema_0" class="form-control">
                                        <option :value="null">-- Use default --</option>
                                        <option :value="authenticationSchema.id" v-for="authenticationSchema in authenticationSchemaConfigurations">{{ authenticationSchema.label }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-show="isSectionOpen('authenticationSchemas')">
                                <label class="col-sm-4 text-right control-label" for="DefaultModeAuthenticationSchema_1">Default Admin Authentication Schema</label>
                                <div class="col-sm-8">
                                    <select v-model="defaultModeAuthenticationSchema['Admin']" id="DefaultModeAuthenticationSchema_1" class="form-control">
                                        <option :value="null">-- Use default --</option>
                                        <option :value="authenticationSchema.id" v-for="authenticationSchema in authenticationSchemaConfigurations">{{ authenticationSchema.label }}</option>
                                    </select>
                                </div>
                            </div>
                            <hr v-show="isSectionOpen('authenticationSchemas')" />
                            <div v-show="isSectionOpen('authenticationSchemas')">
                                <div class="form-group row" v-for="(authenticationSchemaConfiguration, authenticationSchemaConfigurationIndex) in authenticationSchemaConfigurations">
                                    <!--
                <input type="hidden" data-bind="value: name, attr: { name: 'AuthenticationSchemaConfigurations['+$index()+'].Key' }" />
                -->
                                    <label class="col-sm-4 text-right control-label" :for="'AuthenticationSchemaConfigurations' + authenticationSchemaConfigurationIndex + '_Value_Enabled'">{{ authenticationSchemaConfiguration.label }}</label>
                                    <div class="col-sm-8">
                                        <select v-model="authenticationSchemaConfiguration.enabled" :id="'AuthenticationSchemaConfigurations' + authenticationSchemaConfigurationIndex + '_Value_Enabled'" class="form-control">
                                            <option :value="null">-- Use default --</option>
                                            <option value="true">Enabled</option>
                                            <option value="false">Disabled</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('inheritance')">
                                <a tabindex="0" role="button" style="color: inherit">Inheritance</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('inheritance') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('inheritance')">
                                <div class="form-group row" v-for="(inheritConfiguration, inheritConfigurationindex) in inheritConfigurations">
                                    <!--
                <input type="hidden" data-bind="value: name, attr: { name: 'InheritConfigurations['+$index()+'].Key' }" />
                -->
                                    <label class="col-sm-4 text-right control-label" :for="'InheritConfigurations' + inheritConfigurationindex + '_Value_Enabled'">{{ inheritConfiguration.label }}</label>
                                    <div class="col-sm-8">
                                        <select v-model="inheritConfiguration.enabled" :id="'InheritConfigurations' + inheritConfigurationindex + '_Value_Enabled'" class="form-control">
                                            <option :value="null">-- Use default --</option>
                                            <option value="true">Enabled</option>
                                            <option value="false">Disabled</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('widgets')">
                                <a tabindex="0" role="button" style="color: inherit">Widgets</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('widgets') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('widgets')">
                                <fieldset>
                                    <legend>Allowed Origins</legend>
                                    <div class="form-group row" v-for="(allowedOrigin, allowedOriginIndex) in allowedOrigins">
                                        <label :for="'AllowedOrigins_' + allowedOriginIndex" class="sr-only control-label">Origin {{ allowedOriginIndex + 1 }})</label>
                                        <div class="input-group col-12">
                                            <input class="form-control" type="text" v-model="allowedOrigins[allowedOriginIndex]" :id="'AllowedOrigins_' + allowedOriginIndex" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary icon icon-trash" title="Delete" aria-label="Delete" @click.prevent="removeAllowedOrigin(allowedOrigin, allowedOriginIndex)" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row col-12">
                                        <button class="btn btn-outline-secondary" @click.prevent="addAllowedOrigin">Add Origin</button>
                                    </div>
                                </fieldset>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('analytics')">
                                <a tabindex="0" role="button" style="color: inherit">Analytics</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('analytics') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('analytics')">
                                <fieldset>
                                    <legend>Google Analytics Ids</legend>
                                    <div class="form-group row" v-for="(googleAnalyticsId, googleAnalyticsIdIndex) in googleAnalyticsIds">
                                        <label :for="'GoogleAnalyticsIds_' + googleAnalyticsIdIndex" class="sr-only control-label">Google Analytics Id {{ googleAnalyticsIdIndex + 1 }}</label>
                                        <div class="input-group col-12">
                                            <input class="form-control" type="text" v-model="googleAnalyticsIds[googleAnalyticsIdIndex]" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary icon icon-trash" title="Delete" aria-label="Delete" @click.prevent="removeGoogleAnalyticsId(googleAnalyticsId, googleAnalyticsIdIndex)" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row col-12">
                                        <button class="btn btn-outline-secondary" @click.prevent="addGoogleAnalyticsId()">Add Id</button>
                                    </div>
                                </fieldset>
                            </div>
                        </fieldset>
                        <fieldset class="tenant-fieldset" v-if="dataRetentionEnabled">
                            <legend class="text-uppercase" @click.prevent="toggleSectionOpen('dataRetention')">
                                <a tabindex="0" role="button" style="color: inherit">Data Retention</a>
                                &nbsp;<span class="float-right"><span class="icon" :class="['icon-' + (isSectionOpen('dataRetention') ? 'caret-up' : 'caret-down')]"></span></span>
                            </legend>
                            <div v-show="isSectionOpen('dataRetention')">
                                <div class="alert alert-danger">Setting the Data Retention Period will lead to submissions being PERMANENTLY and IRREVERSIBLY DELETED! Please triply check this is what you intend!</div>
                                <div class="form-group row">
                                    <label class="col-sm-4 text-right control-label" for="periodBetweenStartedAndGraceInDays">Data Retention Period in Days</label>
                                    <div class="col-sm-8 input-group">
                                        <input class="form-control" type="text" id="periodBetweenStartedAndGraceInDays" v-model="periodBetweenStartedAndGraceInDays" />
                                        <div class="input-group-append">
                                            <span class="input-group-text">Days</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 text-right control-label" for="periodBetweenGraceAndPurgeInDays">Grace Period in Days</label>
                                    <div class="col-sm-8 input-group">
                                        <input class="form-control" type="text" id="periodBetweenGraceAndPurgeInDays" v-model="periodBetweenGraceAndPurgeInDays" />
                                        <div class="input-group-append">
                                            <span class="input-group-text">Days</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <br />
            </div>
        </div>
    </div>
</template>
<script lang="ts">
const CUSTOM_LESS_KEY = "CustomLess";
import { defineComponent, ref, computed, inject, SetupContext, reactive, Ref, onActivated } from "vue";
import { fetchXsrf, throwIfNonSuccessStatus } from "@/lib/fetchHelpers.3";
import { getXsftHeader } from "@/lib/getXsrfToken.3";
import AsyncOperationStatus from "@/lib/AsyncOperationStatus.3.vue";
import AsyncOperationErrors from "@/lib/AsyncOperationErrors.3.vue";
import getData from "../../lib/getData";
import LoadingPlaceholder from "@/lib/LoadingPlaceholder.3.vue";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import HelpIcon from "@/lib/HelpIcon.3.vue";
import ImportModal from "./ImportModal.3.vue";
import ExportModal from "./ExportModal.3.vue";
import DeleteModal from "./DeleteModal.3.vue";
import DfTinyMceEditor from "@/lib/DFTinyMceEditor.3.vue";
import tinymce, { Editor, RawEditorOptions } from "tinymce";
import generateGuid from "@/lib/generateGuid";
import { useMainStore } from "@/mainStore";
import { asyncComputed } from "@vueuse/core";
import { showModalInjectKey, loadUserDataInjectKey, changePageInjectKey } from "@/AppShell.3.vue.InjectKeys";
import { ErrorDetails as ErrorDetailsTs } from "@cs-ts/error-details";
import { ErrorDetails as ErrorDetailsCs } from "@cs/ErrorDetails";
import { Table } from "@cs-ts/table";
import { ComponentConfiguration as ComponentConfigurationTs } from "@cs-ts/component-configuration";
import { ComponentConfiguration as ComponentConfigurationCs } from "@cs/ComponentConfiguration";
import { RolePermissionConfiguration } from "@cs-ts/role-permission-configuration";
import { PageCountLimitConfiguration } from "@cs-ts/page-count-limit-configuration";
import { AuthenticationSchemaConfiguration } from "@cs-ts/authentication-schema-configuration";
import { InheritConfiguration } from "@cs-ts/inherit-configuration";
import { EditTenantViewModel } from "@cs/EditTenantViewModel";
import { SuccessResult } from "@cs/SuccessResult";
import { FailureResult } from "@cs/FailureResult";
import { FeatureFlag } from "@cs/FeatureFlag";
import { isNullOrWhitespace } from "@/lib/whitespaceMethods";
import { KnownFeatureFlags } from "@cs/KnownFeatureFlags";
type ExtendWithId<T> = T & { id: string };
type TableExtended = Omit<Table, "data"> & { keys: (string | null)[]; data: (string | null)[][] };
type ComponentConfigurationExtended = Omit<ComponentConfigurationTs, "tables"> & { tables: TableExtended[] };
type Options = { label: string; value: string };
interface TenantDataRefs {
    code: Ref<string>;
    deletable: Ref<string>;
    urlSlug: Ref<string>;
    domain: Ref<string>;
    displayLabel: Ref<string>;
    externalHomePageUrl: Ref<string>;
    description: Ref<string>;
    tier: Ref<string>;
    publicAreaEnabled: Ref<string>;
    adminAreaEnabled: Ref<string>;
    type: Ref<string>;
    parentCode: Ref<string>;
    hasLogoImage: Ref<boolean>;
    hasFaviconImage: Ref<boolean>;
    logoAlt: Ref<string>;
    faviconAlt: Ref<string>;
    billingServiceCode: Ref<string>;
    billingCustomerId: Ref<string>;
    billingLogin: Ref<string>;
    billingStoredPaymentId: Ref<string>;
    billingPerUserCost: Ref<string>;
    billingUserMinimalCost: Ref<string>;
    billingTenantInstanceCost: Ref<string>;
    timeZone: Ref<string>;
    primaryColor: Ref<string>;
    secondaryColor: Ref<string>;
    customLess: Ref<string>;
    customFooterHtml: Ref<string>;
    customNotFoundHtml: Ref<string>;
    customErrorHtml: Ref<string>;
    customUserInviteEmailSubject: Ref<string>;
    customUserInviteEmailHtml: Ref<string>;
    customSessionExpiredHtml: Ref<string>;
    periodBetweenStartedAndGraceInDays: Ref<string>;
    periodBetweenGraceAndPurgeInDays: Ref<string>;

    [key: string]: Ref<string | boolean>;
}

export default defineComponent({
    components: {
        AsyncOperationStatus,
        AsyncOperationErrors,
        LoadingPlaceholder,
        LoadingWheel,
        DfTinyMceEditor,
        HelpIcon,
    },
    props: ["settings"],
    setup(props, { emit }: SetupContext) {
        const mainStore = useMainStore();
        const showModal = inject(showModalInjectKey)!;
        const loadUserData = inject(loadUserDataInjectKey)!;

        const logoImageRef = ref<HTMLInputElement>(null!);
        const faviconImageRef = ref<HTMLInputElement>(null!);

        const backendUrlSlug = ref<string | null>(null);
        const parentTenantOptions = ref<Options[]>([]); // value label
        const tierOptions = ref<Options[]>([]); // value label
        const timeZoneOptions = ref<Options[]>([]); // value label
        const typeOptions = ref<Options[]>([]); // value label
        const saveCustomLessPromise = ref<Promise<void> | null>(null);
        const setStyleEditorModePromise = ref<Promise<void>>(null!);
        const saveStatus = ref<string | null>(null);
        const saveErrors = ref<string[]>([]);
        const saveErrorsDetailed = ref<ErrorDetailsTs[]>([]);
        const loading = ref(true);
        const sectionOpen = reactive({
            logo: false,
            design: false,
            billing: false,
            controls: false,
            role: false,
            permission: false,
            pageCountLimits: false,
            authenticationSchemas: false,
            inheritance: false,
            widgets: false,
            analytics: false,
            dataRetention: false,
        });
        const customLessSaveStatus = ref("");
        const customLessSaveErrors = ref<string[]>([]);
        const customLessSaveErrorsDetailed = ref<ErrorDetailsTs[]>([]);
        const componentConfigurations = ref<ExtendWithId<ComponentConfigurationExtended>[]>([]); // id, enabled label tables[ name, keys[], rows[data[]], ]
        const roleConfigurations = ref<ExtendWithId<RolePermissionConfiguration>[]>([]); //id, enabled, label
        const permissionConfigurations = ref<ExtendWithId<RolePermissionConfiguration>[]>([]); //id, enabled, label
        const pageCountLimitConfigurations = ref<ExtendWithId<PageCountLimitConfiguration>[]>([]); // id, count, label,
        const defaultAuthenticationSchema = ref<string>(null!);
        const defaultModeAuthenticationSchema = ref<Record<string, string>>({});
        const authenticationSchemaConfigurations = ref<ExtendWithId<AuthenticationSchemaConfiguration>[]>([]); // id, enabled, label
        const inheritConfigurations = ref<ExtendWithId<InheritConfiguration>[]>([]); // id, enabled, label
        const allowedOrigins = ref<(string | null)[]>([]); // string
        const googleAnalyticsIds = ref<(string | null)[]>([]); // string

        const dataRetentionEnabled = asyncComputed(() => mainStore.isFeatureFlagActiveAsync(KnownFeatureFlags.PurgingSubmissionsActive.Id));

        const tenantDataRefs: TenantDataRefs = {
            code: ref(null!),
            deletable: ref(null!),
            urlSlug: ref(null!),
            domain: ref(null!),
            displayLabel: ref(null!),
            externalHomePageUrl: ref(null!),
            description: ref(null!),
            tier: ref(null!),
            publicAreaEnabled: ref(null!),
            adminAreaEnabled: ref(null!),
            type: ref(null!),
            parentCode: ref(null!),
            hasLogoImage: ref(false),
            hasFaviconImage: ref(false),
            logoAlt: ref(null!),
            faviconAlt: ref(null!),
            billingServiceCode: ref(null!),
            billingCustomerId: ref(null!),
            billingLogin: ref(null!),
            billingStoredPaymentId: ref(null!),
            billingPerUserCost: ref(null!),
            billingUserMinimalCost: ref(null!),
            billingTenantInstanceCost: ref(null!),
            timeZone: ref(null!),
            primaryColor: ref(null!),
            secondaryColor: ref(null!),
            customLess: ref(null!),
            customFooterHtml: ref(null!),
            customNotFoundHtml: ref(null!),
            customErrorHtml: ref(null!),
            customUserInviteEmailSubject: ref(null!),
            customUserInviteEmailHtml: ref(null!),
            customSessionExpiredHtml: ref(null!),
            periodBetweenStartedAndGraceInDays: ref(null!),
            periodBetweenGraceAndPurgeInDays: ref(null!),
        };

        const hasCustomLessErrors = computed(() => {
            return saveErrorsDetailed.value.find(error => error.key == CUSTOM_LESS_KEY) != null;
        });
        const inviteEmailContentMenuHandler = computed(() => {
            return {
                updateEditorConfig: updateEditorConfig,
                registerContentMenu: registerContentMenu,
            };
        });

        const indexUrl = asyncComputed(() => {
            return mainStore.getUrl("adminTenantManagementIndex");
        });
        const logoUrl = asyncComputed(() => {
            return backendUrlSlug.value == null ? null : mainStore.getUrl("logo", { tenantUrlSlug: backendUrlSlug.value, editorMode: !notInStyleEditorMode.value });
        });
        const faviconUrl = asyncComputed(() => {
            return backendUrlSlug.value == null ? null : mainStore.getUrl("favicon", { tenantUrlSlug: backendUrlSlug.value, editorMode: !notInStyleEditorMode.value });
        });
        const notInStyleEditorMode = asyncComputed(async () => {
            return !(await mainStore.isFeatureFlagActiveAsync("StyleEditorMode"));
        });

        const toggleSectionOpen = (type: keyof typeof sectionOpen) => {
            sectionOpen[type] = !sectionOpen[type];
        };
        const isSectionOpen = (type: keyof typeof sectionOpen) => {
            return sectionOpen[type];
        };
        const removeRow = (table: TableExtended, _row: unknown, rowIndex: number) => {
            table.data!.splice(rowIndex, 1);
        };
        const addRow = (table: TableExtended) => {
            table.data!.push(
                table.keys.map(i => {
                    if (i == "Key") {
                        return generateGuid();
                    } else {
                        return null;
                    }
                }),
            );
        };
        const removeAllowedOrigin = (_allowedOrigin: string | null, allowedOriginIndex: number) => {
            allowedOrigins.value.splice(allowedOriginIndex, 1);
        };
        const addAllowedOrigin = () => {
            allowedOrigins.value.push(null);
        };
        const removeGoogleAnalyticsId = (_googleAnalyticsId: string | null, googleAnalyticsIdIndex: number) => {
            googleAnalyticsIds.value.splice(googleAnalyticsIdIndex, 1);
        };
        const addGoogleAnalyticsId = () => {
            googleAnalyticsIds.value.push(null);
        };
        const exportFunc = async (event: Event) => {
            showModal(
                ExportModal,
                {
                    code: tenantDataRefs.code.value,
                    triggerElement: event.target,
                },
                {
                    clickToClose: false,
                    height: "auto",
                    width: Math.min(0.9 * window.innerWidth, 600),
                },
            );
        };
        const importFunc = async (event: Event) => {
            showModal(
                ImportModal,
                {
                    code: tenantDataRefs.code.value,
                    confirmCallback: () => {
                        // Do nothing
                    },
                    triggerElement: event.target,
                },
                {
                    clickToClose: false,
                    height: "auto",
                    width: Math.min(0.9 * window.innerWidth, 900),
                },
            );
        };
        const showDeleteModal = async (event: Event) => {
            if (!tenantDataRefs.deletable.value) {
                alert("Not deletable (does it have subtenants?)");
                return;
            }
            showModal(
                DeleteModal,
                {
                    code: tenantDataRefs.code.value,
                    deleteCallback: () => {
                        emit("change-page", { page: "AdminTenantManagementIndex" });
                        // Do nothing
                    },
                    triggerElement: event.target,
                },
                {
                    height: "auto",
                    width: Math.min(0.9 * window.innerWidth, 400),
                },
            );
        };
        const enableStyleEditorMode = () => {
            setStyleEditorModePromise.value = (async () => {
                var saveUrl = await mainStore.getUrl("userSetFeatureFlag", { code: tenantDataRefs.code.value });
                var uploadData = new FormData();
                uploadData.append("id", "StyleEditorMode");
                uploadData.append("setTo", true.toString());
                const response = await fetchXsrf(mainStore, saveUrl, {
                    method: "POST",
                    credentials: "same-origin",
                    body: uploadData,
                });
                throwIfNonSuccessStatus(response);
                const result: FeatureFlag = await response.json();
                const time = result.ActiveOn as unknown as string;
                const diff = new Date(time).getTime() - new Date().getTime();
                await new Promise(r => setTimeout(r, diff));
                await loadUserData();
            })();
            return setStyleEditorModePromise.value;
        };
        const saveCustomLess = async () => {
            return (saveCustomLessPromise.value = (async () => {
                var saveUrl = await mainStore.getUrl("adminTenantManagementEditSaveCustomLess", { code: tenantDataRefs.code.value });
                const formData = new FormData(); // TODO json?
                function appendFormData(key: string, value: string | null) {
                    //if (value != null) {
                    formData.append(key, value == null ? "" : value);
                    //}
                }
                appendFormData("code", tenantDataRefs.code.value);
                appendFormData("customLess", tenantDataRefs.customLess.value);
                const saveResponse = await fetch(saveUrl, {
                    method: "POST",
                    headers: await getXsftHeader(mainStore),
                    credentials: "same-origin",
                    body: formData,
                });
                throwIfNonSuccessStatus(saveResponse);
                const saveJson: SuccessResult & FailureResult = await saveResponse.json();
                if (saveJson.Success) {
                    customLessSaveStatus.value = "ok";
                    customLessSaveErrors.value = [];
                    removeCustomLessErrors();
                } else {
                    customLessSaveStatus.value = "fail";
                    customLessSaveErrors.value = saveJson.Errors || ["Unknown error occurred"];
                    customLessSaveErrorsDetailed.value = (saveJson.ErrorsDetailed || [{ Key: null, Message: "Unknown error occurred" }]).map(i => ({ key: i.Key, message: i.Message }));
                    // throw new Error(JSON.stringify(saveJson.Errors));
                }
            })());
        };
        const removeCustomLessErrors = () => {
            var filterFunc = <T,>(errors: T[]) => {
                var customLessIndexes = saveErrorsDetailed.value.flatMap((error, index) => (error.key == CUSTOM_LESS_KEY ? index : []));
                return errors.filter((_, index: number) => !customLessIndexes.includes(index));
            };
            saveErrors.value = filterFunc(saveErrors.value);
            saveErrorsDetailed.value = filterFunc(saveErrorsDetailed.value);
        };
        const save = async () => {
            saveStatus.value = "in-progress";
            var saveUrl = await mainStore.getUrl("adminTenantManagementEditSave", { code: tenantDataRefs.code.value });
            const formData = new FormData(); // TODO json?
            function appendFormData(key: string, value: string | null) {
                //if (value != null) {
                formData.append(key, value == null ? "" : value);
                //}
            }
            appendFormData("Code", tenantDataRefs.code.value);
            const savedUrlSlug = tenantDataRefs.urlSlug.value;
            appendFormData("UrlSlug", savedUrlSlug);
            appendFormData("Domain", tenantDataRefs.domain.value);
            appendFormData("DisplayLabel", tenantDataRefs.displayLabel.value);
            appendFormData("ExternalHomePageUrl", tenantDataRefs.externalHomePageUrl.value);
            appendFormData("Description", tenantDataRefs.description.value);
            appendFormData("Type", tenantDataRefs.type.value);
            appendFormData("Tier", tenantDataRefs.tier.value);
            appendFormData("TimeZone", tenantDataRefs.timeZone.value);
            appendFormData("PublicAreaEnabled", tenantDataRefs.publicAreaEnabled.value);
            appendFormData("AdminAreaEnabled", tenantDataRefs.adminAreaEnabled.value);
            appendFormData("ParentCode", tenantDataRefs.parentCode.value);
            appendFormData("HasLogoImage", tenantDataRefs.hasLogoImage.value.toString());
            appendFormData("HasFaviconImage", tenantDataRefs.hasFaviconImage.value.toString());
            const logoFiles = logoImageRef.value.files!;
            if (logoFiles.length > 0) {
                const newLogoFile = logoFiles[0];
                formData.append("LogoImage", newLogoFile, newLogoFile.name);
            }
            const faviconFiles = faviconImageRef.value.files!;
            if (faviconFiles.length > 0) {
                const newFaviconFile = faviconFiles[0];
                formData.append("FaviconImage", newFaviconFile, newFaviconFile.name);
            }
            appendFormData("LogoAlt", tenantDataRefs.logoAlt.value);
            appendFormData("PrimaryColor", tenantDataRefs.primaryColor.value);
            appendFormData("SecondaryColor", tenantDataRefs.secondaryColor.value);
            appendFormData("CustomLess", tenantDataRefs.customLess.value);
            appendFormData("CustomFooterHtml", tenantDataRefs.customFooterHtml.value);
            appendFormData("CustomNotFoundHtml", tenantDataRefs.customNotFoundHtml.value);
            appendFormData("CustomErrorHtml", tenantDataRefs.customErrorHtml.value);
            appendFormData("CustomUserInviteEmailSubject", tenantDataRefs.customUserInviteEmailSubject.value);
            appendFormData("CustomUserInviteEmailHtml", tenantDataRefs.customUserInviteEmailHtml.value);
            appendFormData("CustomSessionExpiredHtml", tenantDataRefs.customSessionExpiredHtml.value);
            componentConfigurations.value.forEach((c, ci) => {
                appendFormData("ComponentConfigurations[" + ci + "].Key", c.id);
                appendFormData("ComponentConfigurations[" + ci + "].Value.Enabled", (c.enabled || "").toString());
                c.tables!.forEach((t, ti) => {
                    appendFormData("ComponentConfigurations[" + ci + "].Value.Tables[" + ti + "].Name", t.name!);
                    appendFormData("ComponentConfigurations[" + ci + "].Value.Tables[" + ti + "].Schema[0].Name", "Ignored");
                    t.data!.forEach((r, ri) => {
                        r.forEach((ce, cei) => {
                            appendFormData("ComponentConfigurations[" + ci + "].Value.Tables[" + ti + "].Data[" + ri + "][" + cei + "].Value", ce);
                            appendFormData("ComponentConfigurations[" + ci + "].Value.Tables[" + ti + "].Data[" + ri + "][" + cei + "].Key", t.keys[cei]);
                        });
                    });
                });
            });
            roleConfigurations.value.forEach((r, ri) => {
                appendFormData("RoleConfigurations[" + ri + "].Key", r.id);
                appendFormData("RoleConfigurations[" + ri + "].Value.Enabled", (r.enabled || "").toString());
            });
            permissionConfigurations.value.forEach((r, ri) => {
                appendFormData("PermissionConfigurations[" + ri + "].Key", r.id);
                appendFormData("PermissionConfigurations[" + ri + "].Value.Enabled", (r.enabled || "").toString());
            });
            permissionConfigurations.value.forEach((r, ri) => {
                appendFormData("PermissionConfigurations[" + ri + "].Key", r.id);
                appendFormData("PermissionConfigurations[" + ri + "].Value.Enabled", (r.enabled || "").toString());
            });
            pageCountLimitConfigurations.value.forEach((r, ri) => {
                appendFormData("PageCountLimitConfigurations[" + ri + "].Key", r.id);
                appendFormData("PageCountLimitConfigurations[" + ri + "].Value.Count", (r.count || "").toString());
            });
            appendFormData("DefaultAuthenticationSchema", defaultAuthenticationSchema.value);
            Object.entries(defaultModeAuthenticationSchema.value).forEach((r, ri) => {
                appendFormData("DefaultModeAuthenticationSchema[" + ri + "].Key", r[0]);
                appendFormData("DefaultModeAuthenticationSchema[" + ri + "].Value", r[1]);
            });
            authenticationSchemaConfigurations.value.forEach((r, ri) => {
                appendFormData("AuthenticationSchemaConfigurations[" + ri + "].Key", r.id);
                appendFormData("AuthenticationSchemaConfigurations[" + ri + "].Value.Enabled", (r.enabled || "").toString());
            });
            inheritConfigurations.value.forEach((r, ri) => {
                appendFormData("InheritConfigurations[" + ri + "].Key", r.id);
                appendFormData("InheritConfigurations[" + ri + "].Value.Enabled", (r.enabled || "").toString());
            });
            allowedOrigins.value.forEach((r, ri) => {
                appendFormData("AllowedOrigins[" + ri + "]", r);
            });
            googleAnalyticsIds.value.forEach((r, ri) => {
                appendFormData("GoogleAnalyticsIds[" + ri + "]", r);
            });
            appendFormData("BillingServiceCode", tenantDataRefs.billingServiceCode.value);
            appendFormData("BillingCustomerId", tenantDataRefs.billingCustomerId.value);
            appendFormData("BillingLogin", tenantDataRefs.billingLogin.value);
            appendFormData("BillingStoredPaymentId", tenantDataRefs.billingStoredPaymentId.value);
            appendFormData("BillingPerUserCost", tenantDataRefs.billingPerUserCost.value);
            appendFormData("BillingUserMinimalCost", tenantDataRefs.billingUserMinimalCost.value);
            appendFormData("BillingTenantInstanceCost", tenantDataRefs.billingTenantInstanceCost.value);
            appendFormData("PeriodBetweenStartedAndGraceInDays", tenantDataRefs.periodBetweenStartedAndGraceInDays.value);
            appendFormData("PeriodBetweenGraceAndPurgeInDays", tenantDataRefs.periodBetweenGraceAndPurgeInDays.value);
            try {
                const saveResponse = await fetch(saveUrl, {
                    method: "POST",
                    headers: await getXsftHeader(mainStore),
                    credentials: "same-origin",
                    body: formData,
                });
                throwIfNonSuccessStatus(saveResponse);
                const saveJson: SuccessResult & FailureResult = await saveResponse.json();
                if (saveJson.Success) {
                    backendUrlSlug.value = savedUrlSlug;
                    saveStatus.value = "ok";
                    saveErrors.value = [];
                    saveErrorsDetailed.value = [];
                } else {
                    saveStatus.value = "fail";
                    saveErrors.value = saveJson.Errors || ["Unknown error occurred"];
                    saveErrorsDetailed.value = (saveJson.ErrorsDetailed || [{ Key: null, Message: "Unknown error occurred" }]).map((i: ErrorDetailsCs) => ({ key: i.Key, message: i.Message }));
                }
                if (!hasCustomLessErrors.value) {
                    saveCustomLessPromise.value = null;
                }
            } catch (err) {
                saveStatus.value = "fail";
                saveErrors.value = ["Unknown error occurred"];
                saveErrorsDetailed.value = [{ key: null!, message: "Unknown error occurred" }];
                throw new Error(err as string);
            }
        };
        const updateEditorConfig = (defaultConfig: RawEditorOptions) => {
            const modifiedConfig = structuredClone(defaultConfig); // Make a new copy to avoid sharing configs to other editor instances
            modifiedConfig.noneditable_class = "noneditable";
            modifiedConfig.text_patterns = [{ start: "{{", end: "}}", cmd: "insertVariable", value: { name: null, fromMenu: false } }];
            return modifiedConfig;
        };
        const registerContentMenu = (editor: Editor) => {
            addEditorCommand(editor);
            const emailVariables = [
                {
                    text: "Invite URL",
                    name: "inviteUrl",
                },
                {
                    text: "Expiration Date",
                    name: "expirationDate",
                },
                {
                    text: "Message",
                    name: "message",
                },
                {
                    text: "Tenant Name",
                    name: "tenantName",
                },
                {
                    text: "Last Name",
                    name: "lastName",
                },
                {
                    text: "First Name",
                    name: "firstName",
                },
            ];
            const insertContent = (name: string) => () => {
                editor.execCommand("insertVariable", false, { name, fromMenu: true });
            };
            editor.ui.registry.addMenuButton("inviteEmailContentMenu", {
                text: "Variables",
                fetch: callback => {
                    callback(emailVariables.map(variable => ({ type: "menuitem", text: variable.text, onAction: insertContent(variable.name) })));
                },
            });
        };
        const addEditorCommand = (editor: Editor) => {
            editor.addCommand("insertVariable", (_, { name, fromMenu }) => {
                editor.selection.getBookmark();
                if (!editor.selection.isCollapsed() && fromMenu) {
                    editor.selection.collapse(false);
                }
                editor.insertContent(`<span class="invite-email noneditable">{{${name ?? tinymce.trim(editor.selection.getSel()!.focusNode!.textContent ?? "")}}}</span>`);
            });
        };

        const _onActivated = async () => {
            loading.value = true;
            saveStatus.value = null;
            saveCustomLessPromise.value = null;
            saveStatus.value = null;
            saveErrors.value = [];
            saveErrorsDetailed.value = [];
            const tenantData = await getData(
                mainStore,
                "AdminTenantManagementEdit",
                () => mainStore.getUrl("adminTenantManagementEditData", { code: props.settings.code }),
                i => i.Code == props.settings.code,
            );
            Object.keys(tenantDataRefs).forEach(k => {
                tenantDataRefs[k].value = tenantData[k[0].toUpperCase() + k.slice(1)];
            });
            backendUrlSlug.value = tenantDataRefs.urlSlug.value;
            var comparer = new Intl.Collator([], { sensitivity: "base" });
            componentConfigurations.value = Object.keys(tenantData.ComponentConfigurations)
                .map(k => {
                    const d: ComponentConfigurationCs = tenantData.ComponentConfigurations[k];
                    return <ExtendWithId<ComponentConfigurationExtended>>{
                        id: k,
                        enabled: d.Enabled,
                        label: d.Label,
                        tables: d.Tables!.map(t => ({
                            testMode: false,
                            dataCount: t.Data!.length,
                            name: t.Name,
                            keys: t.Data![0].map(i => i.Key),
                            data: t.Data!.map(r => r.map(c => (c.Key == "Key" && isNullOrWhitespace(c.Value) ? generateGuid() : c.Value))),
                            schema: [],
                        })),
                    };
                })
                .sort((a, b) => comparer.compare(a.label!, b.label!));
            parentTenantOptions.value = Object.keys(tenantData.TenantOptions)
                .map(k => ({ label: tenantData.TenantOptions[k], value: k }))
                .sort((a, b) => comparer.compare(a.label, b.label));
            tierOptions.value = tenantData.TierOptions.map((i: EditTenantViewModel["TierOptions"]) => ({ label: i, value: i }));
            timeZoneOptions.value = Object.keys(tenantData.TimeZoneOptions).map(k => ({ label: tenantData.TimeZoneOptions[k], value: k }));
            typeOptions.value = tenantData.TypeOptions.map((i: EditTenantViewModel["TypeOptions"]) => ({ label: i, value: i }));
            roleConfigurations.value = Object.keys(tenantData.RoleConfigurations).map(k => {
                const d = tenantData.RoleConfigurations[k];
                return {
                    id: k,
                    enabled: d.Enabled,
                    label: d.Label,
                };
            });
            permissionConfigurations.value = Object.keys(tenantData.PermissionConfigurations).map(k => {
                const d = tenantData.PermissionConfigurations[k];
                return {
                    id: k,
                    enabled: d.Enabled,
                    label: d.Label,
                };
            });
            pageCountLimitConfigurations.value = Object.keys(tenantData.PageCountLimitConfigurations).map(k => {
                const d = tenantData.PageCountLimitConfigurations[k];
                return {
                    id: k,
                    count: d.Count,
                    label: d.Label,
                };
            });
            authenticationSchemaConfigurations.value = Object.keys(tenantData.AuthenticationSchemaConfigurations).map(k => {
                const d = tenantData.AuthenticationSchemaConfigurations[k];
                return {
                    id: k,
                    enabled: d.Enabled,
                    label: d.Label,
                };
            });
            defaultAuthenticationSchema.value = tenantData.DefaultAuthenticationSchema;
            defaultModeAuthenticationSchema.value = tenantData.DefaultModeAuthenticationSchema || {};
            inheritConfigurations.value = Object.keys(tenantData.InheritConfigurations).map(k => {
                const d = tenantData.InheritConfigurations[k];
                return {
                    id: k,
                    enabled: d.Enabled,
                    label: d.Label,
                };
            });
            allowedOrigins.value = (tenantData.AllowedOrigins || []).map((i: EditTenantViewModel["AllowedOrigins"]) => i);
            googleAnalyticsIds.value = (tenantData.GoogleAnalyticsIds || []).map((i: EditTenantViewModel["GoogleAnalyticsIds"]) => i);
            loading.value = false;
        };
        onActivated(_onActivated);

        const expose = {
            // Refs
            logoImageRef,
            faviconImageRef,

            // States
            parentTenantOptions,
            tierOptions,
            timeZoneOptions,
            typeOptions,
            saveCustomLessPromise,
            setStyleEditorModePromise,
            saveStatus,
            saveErrors,
            saveErrorsDetailed,
            loading,
            componentConfigurations,
            roleConfigurations,
            permissionConfigurations,
            pageCountLimitConfigurations,
            defaultAuthenticationSchema,
            defaultModeAuthenticationSchema,
            authenticationSchemaConfigurations,
            inheritConfigurations,
            allowedOrigins,
            googleAnalyticsIds,

            // Computed
            inviteEmailContentMenuHandler,
            indexUrl,
            logoUrl,
            faviconUrl,
            notInStyleEditorMode,
            dataRetentionEnabled,

            // Methods
            toggleSectionOpen,
            isSectionOpen,
            removeRow,
            addRow,
            removeAllowedOrigin,
            addAllowedOrigin,
            removeGoogleAnalyticsId,
            addGoogleAnalyticsId,
            exportFunc,
            importFunc,
            showDeleteModal,
            enableStyleEditorMode,
            saveCustomLess,
            save,

            changePage: inject(changePageInjectKey)!,

            ...tenantDataRefs,
        };

        ("#if JEST");
        //@ts-ignore
        expose.onActivated = _onActivated;
        ("#endif");

        return expose;
    },
});
</script>
